<template>
  <div class="component-container">
    <div class="container-head">
      <i class="iconfont icon-ziliaoshouce-xianxing"></i>
      <span >文章发布</span>
    </div>
    <div class="container-body">
      <div class="form-body">
        <el-table row-class-name="vertical-align-top" :data="data.articleData"
                  :header-cell-style="{ background: '#E5F5F9',fontSize:'16px',color:'#353739' }"
                  :stripe="true">
          <el-table-column prop="type" width="150" label="所属模块">
            <template slot-scope="scope">
              <span v-show="scope.row.postTpCode === ARTICLE_SJD_TYPE_CODE">三角地</span>
              <span v-show="scope.row.postTpCode === ARTICLE_DLB_TYPE_CODE">大喇叭</span>
              <span v-show="scope.row.postTpCode === ARTICLE_CASE_SHARE_TYPE_CODE">动态共享</span>
              <span v-show="scope.row.postTpCode === ARTICLE_CASE_DISCUSS_TYPE_CODE">病例讨论</span>
            </template>
          </el-table-column>
          <el-table-column min-width="150" prop="title" label="标题">
            <template slot-scope="scope">
              <span style="font-size: 16px">{{scope.row.postTitle}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column  min-width="200" prop="content" label="内容">-->
<!--            <template slot-scope="scope">-->
<!--              <span style="font-size: 16px">{{scope.row.postContent| filterContext}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column width="150" prop="userName" label="发布人">
            <template slot-scope="scope">
              <span style="font-size: 16px">{{scope.row.userName}}</span>
            </template>
          </el-table-column>
          <el-table-column width="180" prop="createTm" label="发布时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTm | datetimeFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="status" label="状态">
            <template slot-scope="scope">
              <span v-show="scope.row.status === APPROVE_STATUS_NOT">待审核</span><span
              v-show="scope.row.status === APPROVE_STATUS_AGREE">已通过</span><span
              v-show="scope.row.status === APPROVE_STATUS_REFUSE">已拒绝</span><span
              v-show="scope.row.status === APPROVE_STATUS_DRAFT">草稿</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="150" label="操作">
            <template slot-scope="scope">
              <button class="eims-button eims-button--text" @click="showArticleInfo(scope.row)">查看</button>
              <button class="eims-button eims-button--text"   v-if="isshowbutton(scope.row)"  @click="updateArticleInfo(scope.row)">编辑</button>
              <button class="eims-button eims-button--text" @click="deleteArticleInfo(scope.row)">删除</button>
            </template>
          </el-table-column>
        </el-table>

        <span style="float: right">
              <el-pagination
                layout="sizes, prev, pager, next"
                :total="data.total"
                :page-size="data.pageSize"
                :page-sizes="data.pageSizeArray"
                @current-change="handlePageChange"
                @size-change="handleSizeChange"
                :current-page="data.currentPage"
              >
              </el-pagination>
            </span>
      </div>
    </div>
    <el-dialog
      title="警告"
      :visible.sync="dialogVisible"
      width="30%">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>



    <animation :loadingDataVisible="(!attachmentUploadState || !formInfoSaveState) || data.isLoading" :loadingText="loadingText"></animation>
    <post-update @sensitiveWord="sensitiveWord" v-if="postUpdateVisible" @handlerVisible="handlerVisible" :baseUrl="baseUrl"  :baseUrlUpdate="baseUrlUpdate" @refresh="queryData" :post-code="dialog.postCode" :status="dialog.status" :post-tp-code="dialog.postTpCode"  />

    <post-detail :status="dialog.status" v-if="postDetailVisible" @handlerVisible="handlerVisible" :baseUrl="baseUrl" :post-code="dialog.postCode" />

  </div>
</template>

<script>
  import {Message} from "element-ui";
  import http from "@/utils/axios";
  import cookie from "../../utils/cookie";
  import animation from '@/components/loading/animation'
  import ArticleDetail from "../../components/detail/ArticleDetail";
  import userModule from "../../vuex/modules/userModule";
  import {mapState} from "vuex";
  import {APPROVE_STATUS_AGREE,APPROVE_STATUS_NOT,APPROVE_STATUS_REFUSE,ARTICLE_CASE_DISCUSS_TYPE_CODE} from '@/constants/constants'
  import PostDetail from "../../components/detail/PostDetail";
  import PostCreate from "../../components/detail/PostCreate";
  import PostUpdate from "../../components/detail/PostUpdate";
  import {PAGE_SIZE_ARRAY} from "@/constants/constants";

  export default {
        name: "Article",
      components: {PostUpdate, animation,PostDetail, PostCreate},
      data(){
          return{
            //true是结束,false是正在处理
            attachmentUploadState:true,
            //true是结束,false是正在处理
            formInfoSaveState:true,
            loadingText:null,
            data:{
              articleData:[],
              isLoading:false,
              pageNum: 1,
              pageSize: 10,
              total: 0,
              currentPage: 1,
              pageSizeArray: PAGE_SIZE_ARRAY,
              userId:'',

            },
            approve: {
              status: '-1',
              keyWord: '',
              postCode: '',
              postTpCode: '',
              timeRange: [],
            },

            loadingDataVisible: false,
            //待审核
            APPROVE_STATUS_NOT: '0',
            //已通过
            APPROVE_STATUS_AGREE: '1',
            //已拒绝
            APPROVE_STATUS_REFUSE: '2',
            //草稿数据
            APPROVE_STATUS_DRAFT: '3',
            //三角地
            ARTICLE_SJD_TYPE_CODE: "044-001",
            //大喇叭
            ARTICLE_DLB_TYPE_CODE: "044-002",
            //病例分享
            ARTICLE_CASE_SHARE_TYPE_CODE: "044-003",
            //病例讨论
            ARTICLE_CASE_DISCUSS_TYPE_CODE: "044-004",
            dialog: {
              editedFlag: 'view',
              isShow: false,
              postCode: null,
              postTpCode: null,
              status: null,
              userId:'',
            },
            baseUrl:'/eims-api/user/personal/article/detail',
            baseUrlUpdate:'/eims-api/user/personal/article/update',
            border:true,
            dialogVisible: false,
            postDetailVisible: false,
            postUpdateVisible: false,
            showbutton:false

          }
      },
    created() {
      this.queryData();

    },

      methods:{
        sensitiveWord(items){
          this.$confirm("存在敏感词汇：" + items)
            .then(_ => {
              items()
            })
            .catch(_ => {})
        },

        handlerVisible(flag){
          this.postDetailVisible = flag
          this.postUpdateVisible = flag
        },
        closeDialog(){
          this.dialog.isShow = false;
          this.dialog.editFlag = 'view';
          this.dialog.postCode = null;

        },
          //查看
        showArticleInfo(row){
          this.postDetailVisible = true
          this.border=true;
          this.dialog.editFlag = 'view';
          this.dialog.postCode=row.postCode;
          this.dialog.status=row.status;
          this.dialog.isShow = true;

        },
        //修改
        updateArticleInfo(row){
          this.postUpdateVisible = true;
          this.border=false;
          this.dialog.editFlag = 'update';
          this.dialog.postCode = row.postCode;
          this.dialog.postTpCode = row.postTpCode;
          this.dialog.status=row.status;
          this.dialog.isShow = true;
        },
        //删除
        deleteArticleInfo(row){
          let that = this;
          that.$confirm('确定将' + row.postTitle + '删除？',{
            confirmButtonText: "确定",
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() =>{
            this.deletearticle(row)
          }).catch(()=>{})
        },
        deletearticle(row){
          let obj={
            token:cookie.getCookie("token"),
            data:{
              postCode:row.postCode,
              postTpCode:row.postTpCode,
              status:row.status,
            }

          }
          http.post(window.config.api.baseUrl + '/eims-api/user/personal/article/delete', obj).then(response => {
            if(response.data.code === '00000'){
              Message.success("文章信息删除成功")
            }
          }).finally(() => {
            this.queryData();

          })

        },

        queryData(){
          let obj = {
            token: cookie.getCookie("token"),
            data: {
              pageNum: this.data.pageNum,
              pageSize: this.data.pageSize,
              status: this.approve.status,
              postCode: this.approve.postCode,
              postTpCode: this.approve.postTpCode,


            }
          }
          http.post(window.config.api.baseUrl + '/eims-api/user/personal/article/list', obj).then(value => {
            if (value.data.code === '00000') {

              this.data.articleData = value.data.data.approves
              this.data.total = value.data.data.total
              this.data.userId =value.data.data.userId;


            }
          }).finally(() => {

            this.loadingDataVisible = false
          })

        },

          //分页
        handlePageChange(val) {
          this.data.pageNum = val;
          this.queryData();
        },

        handleSizeChange(val){
          this.data.pageSize = val;
          this.queryData();
        },

        isshowbutton(row) {
          if(this.data.userId!==row.createUserId){
           return false
          }
          if (row.postTpCode === ARTICLE_CASE_DISCUSS_TYPE_CODE) {
            return false
          }else if(row.status === APPROVE_STATUS_NOT || row.status === APPROVE_STATUS_REFUSE || row.status === this.APPROVE_STATUS_DRAFT) {
            return true
          }
        }

      },
    watch:{
      "data.list.length": {
        handler(newVal, oldVal) {
          if (newVal < oldVal) {
            if (oldVal === 1){
              if (this.data.pageNum!==1){
                this.handlePageChange(this.data.pageNum - 1)
              }else {
                this.handlePageChange(1)
              }

            }
          }
        }
      },
    }

    }
</script>

<style scoped>
  /deep/ .form-body .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #F3FDFF !important;
  }
  .eims-button--text {
    border-color: transparent;
    color: #409eff;
    background: transparent;
  }


</style>



// WEBPACK FOOTER //
// src/pages/user/Article.vue